export type DateObject = { month: string; day: string; year: string };

export enum PickerVariants {
  DEFAULT = 'default',
  CYLINDER = 'cylinder',
}
